import React, { useEffect, useState } from "react";
import Papa from "papaparse";
import backArrow from "@assets/icons/arrow-left.svg";
import fileUploadIcon from "@assets/icons/file-upload.svg";
import completedIcon from "@assets/icons/completed.svg";
import incompleteIcon from "@assets/icons/incomplete.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  createQuestionPaper,
  createExamSession,
} from "@services/testCreation";
import styles from "./CreateTest.module.css";
import TestUploadPage from "@components/testuploadcomponent/TestUploadComponent";
import { TEMPLATE_ID } from "@constants/appConstants";
import { EVALUATION_TYPES } from "@constants/evaluationConstants";

type ExamDataType = { name?: string, exam_name?:string, description?: string, exam_date?: string, question_paper_ids?: string[], subject_ids?: number[], grade_ids?: number[] };
function CreateTest() {
  const [searchParams] = useSearchParams();
  const [uploadStatus, setUploadStatus] = React.useState<
    "idle" | "uploading" | "completed" | "error"
  >("idle");
  const [step1Completed, setStep1Completed] = useState(false);
  const [showTestUpload, setShowTestUpload] = useState(false);
  const [uploadedQuestions, setUploadedQuestions] = useState<Array<{ id: string; name: string }>>([]);
  type QuestionPaperDataType = {
    id: string;
    title?: string;
    questions?: any[];
  };

  const [examData, setExamData] = useState<ExamDataType | null>(null);
  const [examId, setExamId] = useState<string | null>(null);
  const [questionPaperId, setQuestionPaperId] = useState<string | null>(null);
  const [questionPaperData, setQuestionPaperData] =
    useState<QuestionPaperDataType | null>(null);
  const [areAllUploadsDone, setAreAllUploadsDone] = useState(false);
  const [finalQuestions, setFinalQuestions] = useState<any[]>([]);
  const [examName, setExamName] = useState<string>('');
  const [examDescription, setExamDescription] = useState<string>('');
  const [masking,setMasking]=useState(false);
  const [evaluationType,setEvaluationType]=useState<string>("");
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  // const handleQuestionPaperDataUpload = (
  //   event: React.ChangeEvent<HTMLInputElement>
  // ) => {
  //   const file = event.target.files?.[0];
  //   if (!file) return;
  //   setUploadStatus("uploading");
  //   Papa.parse(file, {
  //     header: true,
  //     skipEmptyLines: true,
  //     complete: async (results) => {
  //       const rows = results.data as Record<string, string>[];

  //       if (!rows.length) {
  //         setUploadStatus("error");
  //         return;
  //       }
  //       const title = rows[0].title?.trim() || rows[0].Title?.trim() || "";
  //       const sortedRows = [...rows].sort(
  //         (a, b) => Number(a.sequence_number) - Number(b.sequence_number)
  //       );
  //       const questions = sortedRows.map((row) => ({
  //         question_text: row.question_text?.trim() || "",
  //         sample_answers: [
  //           {
  //             sample_answer_text: row.sample_answer_text?.trim() || "",
  //           },
  //         ],
  //         rubric_text: JSON.stringify(row.rubric_text?.trim() || ""),
  //         min_marks: Number(row.min_marks?.trim()) || 0,
  //         max_marks: Number(row.max_marks?.trim()) || 0,
  //       }));
  //       const payload = {
  //         title,
  //         questions,
  //       };
  //       try {
  //         const res = await uploadQuestionPaper(payload);
  //         if (res) {
  //           setUploadStatus("completed");
  //           setQuestionPaperId(res?.id);
  //           setQuestionPaperData(res);
  //         } else {
  //           setUploadStatus("error");
  //         }
  //       } catch (error) {
  //         console.error(error);
  //         setUploadStatus("error");
  //       }
  //     },
  //   });
  // };
  const hanldeStep1Completion = () => {
    setStep1Completed(true);
    setUploadStatus("idle");
  };
  const handleMaskingChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMasking(event.target.checked);
  };
  const handleExamDataUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploadStatus("uploading");
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const rows = results.data as Record<string, string>[];
        const extractedData=rows.map((row) => ({
          name: row.name?.trim() || row.Name?.trim() || "",
          description: row.description?.trim() || row.Description?.trim() || "",
          exam_date: row.exam_date?.trim() || row.Exam_Date?.trim() || "",
          question_paper_ids: [],
          // subject_ids: [Number(row.subject_ids)],
          // grade_ids: [Number(row.grade_ids)],
          subject_ids: row.subject_ids.split(",").map(id => Number(id.trim())),
          grade_ids: row.grade_ids.split(",").map(id => Number(id.trim())),
          exam_name: row.exam_name?.trim() || row.Exam_Name?.trim() || "",
        }));
        console.log("extractedData", extractedData);
        setExamData(extractedData?.[0])
        try {
          // const res = await uploadExamDetails(extractedData?.[0]);
          // if (res) {
          //   setUploadStatus("completed");
          //   setExamId(res?.id);
          //   setExamData(res);
          // } else {
          //   setUploadStatus("error");
          // }
          setTimeout(() => {
            setUploadStatus("completed");
          }, 500);
        } catch (error) {
          setUploadStatus("error");
        }
      },
    });
  };
  // const completeTestCreation = async () => {
  //   const res = await addQuestionPaperToExam(examId, [questionPaperId]);
  //   if (res) {
  //     navigate("/admin-dashboard");
  //   }
  // };
  const handleAddQuestion = () => {
    setShowTestUpload(true);
  };

  const handleQuestionUploaded = (questionObject: any) => {
    const questionNumber = uploadedQuestions.length + 1;
    setUploadedQuestions(prev => [
      ...prev,
      { id: `question_${questionNumber}`, name: `Question ${questionNumber}` }
    ]);
      setFinalQuestions(prev => [...prev, questionObject]);
      setShowTestUpload(false);
  };
  
  const handleSubmitAllQuestions = async () => {
    const payload = {
      title: examName || "Untitled Exam",
      description: examDescription || "",
      questions: finalQuestions,
    };  
    try {
      const res = await createQuestionPaper(payload);
  
      if (!res) {
        alert("Failed to create question paper.");
        return;
      }
    
      const payloadForExamSession = {
        ...examData,
        question_paper_ids: [res.id],
        evaluation_workflow: {
          template_id: TEMPLATE_ID,
        },
        evaluation_type:evaluationType,
        masking_enabled:masking,
      };
      try {
        const examRes = await createExamSession(payloadForExamSession);
        if (examRes) {
          console.log("Exam created", examRes);
          navigate("/admin-dashboard");
        }else {
          alert("Error creating exam session: No response received.");
        }
      } catch (err: any) {
        const status = err?.status;
        if (status === 409) {
          alert(err?.response?.data?.detail); 
        } else {
          alert("Error creating exam");
        }
      }
    } catch (err: any) {
      console.log(err);
      alert("Error creating question paper:\n" + (err?.message || String(err)));
    }
  };

  const onCancel=()=>{
    navigate('/admin-dashboard')
  }
  

  useEffect(() => {
    if (searchParams?.get("exam_id")) {
      setStep1Completed(true);
      setExamId(searchParams?.get("exam_id"));
    }
  }, []);
  return (
    <div className={styles.createTestContainer}>
      <div className={styles.navigation}>
        <button className={styles.backButton} onClick={goBack}>
          <img src={backArrow} alt="Back" /> Back
        </button>
      </div>
      <div className={styles.heading}>
        <h1 className={styles.title}>Create Test</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={`${styles.step} ${styles.active}`}>
          <span>1</span>
          <p>Test details</p>
        </div>
        <div
          className={`${styles.step} ${step1Completed ? styles.active : ""}`}
        >
          <span>2</span>
          <p>Question paper, solutions & Rubrics</p>
        </div>
      </div>
      {!step1Completed ? (
        <>
          <div className={styles.fileUploadContainer}>
            {(() => {
              switch (uploadStatus) {
                case "idle":
                  return (
                    <div
                      className={styles.fileUpload}
                      style={{ display: "flex" }}
                    >
                      <form className={styles.form}>
                        <input
                          type="file"
                          accept=".csv"
                          id="fileUpload"
                          className={styles.fileInput}
                          onChange={(event) => handleExamDataUpload(event)}
                        />
                        <label
                          htmlFor="fileUpload"
                          className={styles.fileLabel}
                        >
                          UPLOAD FILE
                          <img src={fileUploadIcon} alt="Upload" />
                        </label>
                      </form>
                      <div className={styles.fileInfo}>
                        <p>
                          Please{" "}
                          <a href="src/assets/csvs/ExamSchemaTemplate.csv" download>
                            click here
                          </a>{" "}
                          to download a template for .csv file format
                        </p>
                        <p>File size must be less than 20MB</p>
                        <p>Supported format for upload- .csv</p>
                      </div>
                    </div>
                  );

                case "uploading":
                  return (
                    <div className={styles.fileUploading}>
                      <p className={styles.uploadingText}>File Uploading...</p>
                    </div>
                  );

                case "completed":
                  return (
                    <div className={styles.fileUploaded}>
                      <p className={styles.uploadingCompleted}>
                        UPLOAD COMPLETED!{" "}
                        <img src={completedIcon} alt="Completed" />
                      </p>
                    </div>
                  );

                case "error":
                  return (
                    <div className={styles.fileUploadFailed}>
                      <div className={styles.uploadingFailedContainer}>
                        <p className={styles.uploadingFailed}>
                          Oops! Upload Failed{" "}
                        </p>
                        <img src={incompleteIcon} alt="Incomplete" />
                      </div>
                      <p className={styles.errorMessage}>
                        Validation Error. Please Re-upload the file
                      </p>
                      <form className={styles.form}>
                        <input
                          type="file"
                          accept=".csv"
                          id="fileUpload"
                          className={styles.fileInput}
                          onChange={(event) => handleExamDataUpload(event)}
                        />
                        <label
                          htmlFor="fileUpload"
                          className={styles.fileLabel}
                        >
                          Re-UPLOAD FILE
                          <img src={fileUploadIcon} alt="Upload" />
                        </label>
                      </form>
                    </div>
                  );

                default:
                  return null;
              }
            })()}
          </div>
          <div className={styles.buttonContainer}>
            <button className={styles.cancelButton} onClick={onCancel}>Cancel</button>
            <button
              className={styles.continueButton}
              disabled={uploadStatus != "completed"}
              onClick={hanldeStep1Completion}
            >
              Continue
            </button>
          </div>{" "}
        </>
      ) : (
        <>
        {/* masking feature currently disabled */}
        <div className={styles.masking}>
          <label>
            Enable masking: 
            <input
              type="checkbox"
              onChange={handleMaskingChange}
              checked={masking}
            />
          </label>
        </div> 
        <div className={styles.EvaluationTypeContainer}>
          Preferred Evaluation Method: 
          <label>
            <input
              type="radio"
              name="evaluationType"
              value={EVALUATION_TYPES.QUESTION_WISE_EVALUATION}
              onChange={(e) => {setEvaluationType(e.target.value)}}
            />
            Question-wise
          </label>
          <label>
            <input
              type="radio"
              name="evaluationType"
              value={EVALUATION_TYPES.EXAM_SUBMISSION_WISE_EVALUATION}
              onChange={(e) => {setEvaluationType(e.target.value)}}
            />
            Exam-submission-wise
          </label>
        </div>
        <div className={styles.examDetailsSection}>
        <label className={styles.titleLabel}>Test Title</label>
        <input type="text" value={examName} className={styles.inputs}  onChange={(e) => setExamName(e.target.value)}/>
        <label className={styles.titleLabel}>Description</label>
        <input type="text" value={examDescription} className={styles.inputs}  onChange={(e) => setExamDescription(e.target.value)}/>
        </div>
              <div className={styles.questionUploadSection}>
                {/* Display uploaded questions */}
                {uploadedQuestions.length>0 && uploadedQuestions.map((question, index) => (
                  <div key={question.id} className={styles.uploadedQuestion}>
                    <p className={styles.questionRow}>
                      <img src={completedIcon} alt="Completed" />
                      {question.name} uploaded
                    </p>
                  </div>
                ))}
                
                {/* Add Question Button */}
                <button 
                  className={styles.addQuestionButton}
                  onClick={handleAddQuestion}
                >
                  ADD QUESTION
                </button>
              </div>
            
              {showTestUpload && <div className={styles.fileUploadContainer}>
              <TestUploadPage 
                showContinueButton={true}
                onContinue={handleQuestionUploaded}
                onClose={() => setShowTestUpload(false)}
              />
              </div>
            }
            {uploadedQuestions.length > 0 && !showTestUpload && (
            <div className={styles.buttonContainer}>
              <button className={styles.cancelButton} onClick={()=>setUploadedQuestions([])}>Cancel</button>
              <button
                className={styles.submitAllButton}
                onClick={handleSubmitAllQuestions}
                disabled={ !evaluationType || (examName === "" && examDescription === "")}
              >
                Submit
              </button>
            </div>
          )}
            </>
        // <>
        //   <div className={styles.fileUploadContainer}>
        //     {(() => {
        //       switch (uploadStatus) {
        //         case "idle":
        //           return (
        //             <div
        //               className={styles.fileUpload}
        //               style={{ display: "flex" }}
        //             >
        //               <form className={styles.form}>
        //                 <input
        //                   type="file"
        //                   accept=".csv"
        //                   id="fileUpload"
        //                   className={styles.fileInput}
        //                   onChange={(event) =>
        //                     handleQuestionPaperDataUpload(event)
        //                   }
        //                 />
        //                 <label
        //                   htmlFor="fileUpload"
        //                   className={styles.fileLabel}
        //                 >
        //                   UPLOAD FILE
        //                   <img src={fileUploadIcon} alt="Upload" />
        //                 </label>
        //               </form>
        //               <div className={styles.fileInfo}>
        //                 <p>
        //                   Please{" "}
        //                   <a href="/path/to/template.csv" download>
        //                     click here
        //                   </a>{" "}
        //                   to download a template for .csv file format
        //                 </p>
        //                 <p>File size must be less than 20MB</p>
        //                 <p>Supported format for upload- .csv</p>
        //               </div>
        //             </div>
        //           );

        //         case "uploading":
        //           return (
        //             <div className={styles.fileUploading}>
        //               <p className={styles.uploadingText}>File Uploading...</p>
        //             </div>
        //           );

        //         case "completed":
        //           return (
        //             <div className={styles.fileUploaded}>
        //               <p className={styles.uploadingCompleted}>
        //                 UPLOAD COMPLETED!{" "}
        //                 <img src={completedIcon} alt="Completed" />
        //               </p>
        //             </div>
        //           );

        //         case "error":
        //           return (
        //             <div className={styles.fileUploadFailed}>
        //               <div className={styles.uploadingFailedContainer}>
        //                 <p className={styles.uploadingFailed}>
        //                   Oops! Upload Failed{" "}
        //                 </p>
        //                 <img src={incompleteIcon} alt="Incomplete" />
        //               </div>
        //               <p className={styles.errorMessage}>
        //                 Validation Error. Please Re-upload the file
        //               </p>
        //               <form className={styles.form}>
        //                 <input
        //                   type="file"
        //                   accept=".csv"
        //                   id="fileUpload"
        //                   className={styles.fileInput}
        //                   onChange={(event) =>
        //                     handleQuestionPaperDataUpload(event)
        //                   }
        //                 />
        //                 <label
        //                   htmlFor="fileUpload"
        //                   className={styles.fileLabel}
        //                 >
        //                   Re-UPLOAD FILE
        //                   <img src={fileUploadIcon} alt="Upload" />
        //                 </label>
        //               </form>
        //             </div>
        //           );

        //         default:
        //           return null;
        //       }
        //     })()}
        //   </div>
        //   <div className={styles.buttonContainer}>
        //     <button className={styles.cancelButton}>Cancel</button>
        //     <button
        //       className={styles.continueButton}
        //       disabled={uploadStatus != "completed"}
        //       onClick={completeTestCreation}
        //     >
        //       Continue
        //     </button>
        //   </div>
        // </>
      )}
    </div>
  );
}

export default CreateTest;
